import { useRef } from 'react'

import { X } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { InputGroup, InputGroupAddon, InputGroupButton } from '@fortem-monorepo/react-ui'

export interface PayoffBarrierStepFormFieldProps {}

export const PayoffBarrierStepFormField: React.FC<PayoffBarrierStepFormFieldProps> = ({}) => {
  const { control, register, setValue } = useFormContext<{
    payoff_barrier_step: number
  }>()

  const ref = useRef<HTMLInputElement>(null)

  return (
    <FormField
      name="payoff_barrier_step"
      control={control}
      render={({ field: { value, ref: _ref } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Payoff Barrier Step</FormLabel>
              <FormError />
            </div>
            <InputGroup>
              <ControlledNumberInput
                className={
                  'flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent'
                }
                {...register('payoff_barrier_step')}
                ref={ref}
              />
              <InputGroupAddon>
                <InputGroupButton
                  onClick={() => {
                    setValue('payoff_barrier_step', null as unknown as number, {
                      shouldValidate: true,
                    })
                    ref.current?.focus()
                  }}
                  disabled={value === null}
                >
                  <X />
                </InputGroupButton>
              </InputGroupAddon>
            </InputGroup>
          </FormItem>
        )
      }}
    />
  )
}
